const RESULT_MAP = Object.freeze({
  1: { winner: 0 }, 2: { winner: 1 }, 3: { winner: 2 },
  4: { winner: 0, bankerPair: true }, 5: { winner: 0, playerPair: true }, 6: { winner: 0, bankerPair: true, playerPair: true },
  7: { winner: 1, bankerPair: true }, 8: { winner: 1, playerPair: true }, 9: { winner: 1, bankerPair: true, playerPair: true },
  10: { winner: 2, bankerPair: true }, 11: { winner: 2, playerPair: true }, 12: { winner: 2, bankerPair: true, playerPair: true }
});

const WINNER_LABELS = [
  { label: '庄赢', category: 'banker' },
  { label: '闲赢', category: 'player' },
  { label: '和局', category: 'tie' }
];

export function calculateBaccaratSettlement(resultCode, values = []) {
  const code = Number.parseInt(resultCode, 10);
  const result = RESULT_MAP[code];
  if (!result) return null;
  const bets = Array.from({ length: 5 }, (_, index) => Math.max(0, Number(values[index]) || 0));
  const bankerWins = result.winner === 0;
  const playerWins = result.winner === 1;
  const tieWins = result.winner === 2;
  const zones = [
    { status: tieWins ? 'push' : (bankerWins ? 'win' : 'lose'), amount: tieWins ? 0 : (bankerWins ? bets[0] * .95 : -bets[0]) },
    { status: tieWins ? 'push' : (playerWins ? 'win' : 'lose'), amount: tieWins ? 0 : (playerWins ? bets[1] : -bets[1]) },
    { status: tieWins ? 'win' : 'lose', amount: tieWins ? bets[2] * 8 : -bets[2] },
    { status: result.bankerPair ? 'win' : 'lose', amount: result.bankerPair ? bets[3] * 11 : -bets[3] },
    { status: result.playerPair ? 'win' : 'lose', amount: result.playerPair ? bets[4] * 11 : -bets[4] }
  ].map((zone) => {
    const amount = Math.trunc(zone.amount);
    return { ...zone, amount: Object.is(amount, -0) ? 0 : amount };
  });
  const headlineSegments = [WINNER_LABELS[result.winner]];
  if (result.bankerPair) headlineSegments.push({ label: '庄对', category: 'banker' });
  if (result.playerPair) headlineSegments.push({ label: '闲对', category: 'player' });
  return {
    code,
    winner: result.winner,
    bankerPair: Boolean(result.bankerPair),
    playerPair: Boolean(result.playerPair),
    headline: headlineSegments.map(({ label }) => label).join(' · '),
    headlineSegments,
    zones,
    total: zones.reduce((sum, zone) => sum + zone.amount, 0)
  };
}
